module.exports = __webpack_public_path__ + "files/c64264e3ca99d66e063fa229d0fcb118.png";